import React from 'react';

/**
 * Primary Button Component - Enterprise Grade
 * Consistent button styling across the application
 * @param {React.ReactNode} children - Button content
 * @param {function} onClick - Click handler
 * @param {string} variant - Button variant (primary, secondary, outline)
 * @param {string} size - Button size (sm, md, lg)
 * @param {boolean} disabled - Disabled state
 * @param {boolean} fullWidth - Full width button
 * @param {string} type - Button type
 */
const PrimaryButton = ({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  disabled = false,
  fullWidth = false,
  type = 'button',
  className = '',
}) => {
  const baseClasses = 'inline-flex items-center justify-center gap-2 whitespace-nowrap flex-shrink-0 font-medium rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';

  const variantClasses = {
    primary: 'bg-[#2c3e7d] text-white hover:bg-[#3d4f8e] focus:ring-[#2c3e7d]',
    secondary: 'bg-white text-[#2c3e7d] border-2 border-[#2c3e7d] hover:bg-gray-50',
    outline: 'bg-transparent text-[#2c3e7d] border-2 border-[#2c3e7d] hover:bg-[#2c3e7d] hover:text-white',
  };

  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-3 text-lg',
  };

  const widthClass = fullWidth ? 'w-full' : '';
  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${widthClass} ${disabledClasses} ${className}`}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
